import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import AppShell from "@/components/layout/AppShell";
import DashboardPage from "@/pages/DashboardPage";
import EngagementsPage from "@/pages/EngagementsPage";
import EngagementDetailPage from "@/pages/EngagementDetailPage";
import DocumentsPage from "@/pages/DocumentsPage";
import MiniAppsPage from "@/pages/MiniAppsPage";
import TeamPage from "@/pages/TeamPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import MessagesPage from "@/pages/MessagesPage";
import PublicSignPage from "@/pages/PublicSignPage";
import PublicChatPage from "@/pages/PublicChatPage";
import PublicMiniAppPage from "@/pages/PublicMiniAppPage";
import ClientsPage from "@/pages/ClientsPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm label-eyebrow">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/sign/:token" element={<PublicSignPage />} />
          <Route path="/chat/:token" element={<PublicChatPage />} />
          <Route path="/m/:token" element={<PublicMiniAppPage />} />
          <Route
            path="/auth"
            element={
              <PublicOnly>
                <AuthPage />
              </PublicOnly>
            }
          />
          <Route
            path="/"
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="clients/:id" element={<ClientDetailPage />} />
            <Route path="engagements" element={<EngagementsPage />} />
            <Route path="engagements/:id" element={<EngagementDetailPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="mini-apps" element={<MiniAppsPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="messages" element={<MessagesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
